import React from "react"



function PageNotFound () {

    return(
        <div>
            <h1 className="error-page-one">404 Error</h1>
            <h1 className="error-page">Page Not Found</h1>


        </div>
    )
}

export default PageNotFound